import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import styled from 'styled-components';

import { getUserManagementUsers } from 'apis/UserAPI';

import { USER_MANAGEMENT_PAGE_SIZE } from './constants';
import { UserManagementUserType } from './types';
import { UserManagementContext } from './UserManagementContext';
import UserManagementData from './UserManagementData';
import UserManagementHeader from './UserManagementHeader';
import useDataList from '../../utils/hooks/useDataList';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const UserManagement = () => {
  const { items, totalItemsCount, filters, setItems, setPage, setFilters } = useDataList({
    initialState: {
      filters: {
        page: 1,
        pageSize: USER_MANAGEMENT_PAGE_SIZE,
        search: '',
        companies: undefined,
        holdings: undefined,
        feature_flags: undefined,
        positions: undefined,
        is_active: undefined,
        last_login: undefined,
        last_invitation: undefined,
      },
    },
  });
  const [isMultipleSelection, setMultipleSelection] = useState(false);
  const [selectedUserIds, setSelectedUserIds] = useState<number[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<UserManagementUserType[]>([]);

  const clearSelection = () => {
    setSelectedUserIds([]);
    setSelectedUsers([]);
    setMultipleSelection(false);
  };

  useEffect(() => {
    if (!filters.companies?.length) {
      clearSelection();
    }
  }, [filters.companies]);

  const { isLoading, isFetching, refetch } = useQuery({
    queryKey: ['user-management', filters],
    queryFn: () =>
      getUserManagementUsers({
        search: filters.search,
        page: filters.page,
        page_size: filters.pageSize,
        companies: filters.companies,
        holdings: filters.holdings,
        feature_flags: filters.feature_flags,
        positions: filters.positions,
        is_active: filters.is_active,
        last_login: filters.last_login,
        last_invitation: filters.last_invitation,
      }),
    onSuccess: (data: any) => {
      setItems(data);
    },
    refetchOnWindowFocus: false,
  });

  return (
    <UserManagementContext.Provider
      value={{
        loading: isLoading || isFetching,
        items: items ?? [],
        totalItemsCount,
        filters,
        isMultipleSelection,
        selectedUserIds,
        selectedUsers,
        setItems,
        setPage,
        setFilters,
        setMultipleSelection,
        setSelectedUserIds,
        setSelectedUsers,
        clearSelection,
        refetch,
      }}
    >
      <Container>
        <UserManagementHeader />
        <UserManagementData />
      </Container>
    </UserManagementContext.Provider>
  );
};

export default UserManagement;
